import React from "react";
import { Box, TextField, TextFieldProps, Typography, useTheme } from "@mui/material";
import { unstable_useId as useId } from "@mui/material/utils";
import { MobileSignRequestStyles } from "../MobileSignRequest.styles";

type MobileTextFieldProps = TextFieldProps & {
  /** Optional uppercase label rendered above the field. */
  label?: React.ReactNode;
  /** Borderless white variant for use inside tinted containers. */
  filled?: boolean;
};

/**
 * Outlined text field styled to match the mobile design system
 * (light-grey rounded border, navy text, purple focus). All colors come from
 * theme.palette.mobile via the shared styles factory.
 */
const MobileTextField: React.FC<MobileTextFieldProps> = ({
  label,
  sx,
  filled,
  ...props
}) => {
  const theme = useTheme();
  const classes = MobileSignRequestStyles(theme);
  // Associate the visible label with the input so screen readers announce it and
  // tapping the label focuses the field (WCAG 1.3.1 / 3.3.2).
  const generatedId = useId();
  const inputId = props.id ?? generatedId;

  return (
    <Box>
      {label && (
        <Typography
          component="label"
          htmlFor={inputId}
          sx={{ ...classes.fieldLabel, display: "block" }}
        >
          {label}
        </Typography>
      )}
      <TextField
        fullWidth
        id={inputId}
        {...props}
        sx={{
          ...(filled ? classes.textInputFilled : classes.textInput),
          ...sx,
        }}
      />
    </Box>
  );
};

export default MobileTextField;
